export enum LocalStorageKeys {
	Abilities = "abilities",
	Theme = "theme",
	AuthToken = "token",
	RefreshToken = "refreshToken",
	ErrStorage = "errStorage",
	CurrentBotTab = "currentBot",
	WatchList = "watchListEnabled",
	SearchParams = "searchParams",
	GoogleAccessToken = "google_access_token",
	CEXBotCreationData = "botStartingForm",
	ApiBaseUrl = "api_base_url",
	ChartingLibraryDomain = "CHARTING_LIBRARY_DOMAIN",
	TerminalSettings = "terminalSettings",
	DefiTab = "defiTab",
}
